export default "__VITE_ASSET__CuKu9_IH__"